module.exports = __webpack_public_path__ + "img/2_uk.e29af436.svg";